import { Router } from 'vue-router';
import AuthService from '../../services/AuthService';
import LocaleService from '../../services/LocaleService';
import SentryService from '../../services/SentryService';
import { RedirectDuringLoad } from '../../store/fetch';

/**
 * Asynchronous actions that need to run once at startup before the rest
 * of the route resolution and subsequent view rendering.
 * @return {Promise}
 */
async function init(): Promise<void> {
  await Promise.allSettled([
    LocaleService.init(),
    AuthService.init(),
  ]);
  SentryService.loadUser();
}

/**
 * Creates a guard that runs the {@link init} function once and then removes the guard.
 * Route resolution is resumed only after init has finished.
 */
export default function setupInitGuard(router: Router): void {
  const removeGuard = router.beforeEach(async (to, from, next) => {
    removeGuard();
    try {
      await init();
      next();
    } catch (error: any) {
      if (error instanceof RedirectDuringLoad) {
        error.handle(to, from, next);
      } else {
        next(error);
      }
    }
  });
}
